import React, { useState, useEffect } from "react";
import "../styles/ContactUs.css";

// Import your wheel icon
import wheelIcon from "../assets/icons/ship-wheel-icon.png";
import contactImage from "../image/ContactUs-image.png";
import contactIcon from "../assets/icons/contact-icon.png";
import location from "../image/location.jpg";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [submitting, setSubmitting] = useState(false);
  const [responseMessage, setResponseMessage] = useState({ text: "", type: "" });
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setResponseMessage({ text: "", type: "" });
    
    try {
      const response = await fetch("https://ecl.net.in/backende/api/enquiry", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      const data = await response.json();
      
      if (response.ok) {
        setResponseMessage({ 
          text: "Your message has been sent successfully! We'll get back to you soon.", 
          type: "success" 
        });
        setFormData({ name: "", email: "", phone: "", subject: "", message: "" });
      } else {
        setResponseMessage({ 
          text: "Error submitting enquiry: " + (data.message || "Please try again."), 
          type: "error" 
        });
      }
    } catch (error) {
      console.error("Error:", error);
      setResponseMessage({ 
        text: "Server error, please try again later.", 
        type: "error" 
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="contact-container">
      {/* Image Slider */}
      <div className="contact-image-slider">
        <img src={contactImage} alt="Contact Us" />
        <div className="slider-overlay">
          <h1 className="slider-title">Get In Touch With Us</h1>
        </div>
      </div>

      {/* Top Section - Company Address + Location Image */}
      <div className="contact-top-section">
        {/* Left Column - Company Address */}
        <div className={`contact-left-column ${isVisible ? 'fade-in-left' : ''}`}>
          <div className="contact-card">
            <div className="contact-card-header">
              <img src={wheelIcon} alt="Ship Wheel" className="contact-wheel-icon" />
              <span className="contact-header-title">Company Address</span>
            </div>
            
            <div className="contact-card-body">
              <div className="contact-info-section">
                <div className="contact-address-details">
                  <h3 className="contact-company-name">ECL Shipping India Pvt Ltd.,</h3>
                 
                  <p className="contact-address-line">Puyvast House Ground Floor #6,</p>
                  <p className="contact-address-line">Harris Road, Benson Town</p>
                  <p className="contact-address-line">Bangalore - 560046,</p>
                  <p className="contact-address-line">Karnataka, India.</p>
                  
                  <div className="contact-detail">
                    <strong>Email:</strong> 
                    <a href="mailto:eclcommercial@ecl.net.in" className="contact-link">
                      eclcommercial@ecl.net.in
                    </a>
                  </div>
                  
                  <div className="contact-detail">
                    <strong>Phone:</strong> 
                    <a href="tel:+918023335551" className="contact-link">
                      +91 80 2333 5551
                    </a>
                  </div>

                  <div className="contact-detail">
                    <strong>CIN:</strong> U74992TN2006PTC061163
                  </div>
                </div>
              </div>
              
              <div className="contact-map-section">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.5890234875647!2d77.60162731482168!3d12.988824390854089!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae167e12345678%3A0x1234567890abcdef!2sHarris%20Road%2C%20Benson%20Town%2C%20Bengaluru%2C%20Karnataka%20560046!5e0!3m2!1sen!2sin!4v1234567890123!5m2!1sen!2sin"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Company Office Location"
                ></iframe>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column - Location Image ONLY */}
        <div className={`contact-right-column ${isVisible ? 'fade-in-right' : ''}`}>
          <div className="location-image-card-right">
            <div className="location-image-wrapper-right">
              <img src={location} alt="Our Location" className="location-image-right" />
              <div className="location-overlay-right">
                <div className="location-icon-pulse">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="50" height="50">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                  </svg>
                </div>
                <p className="location-text">Visit Our Office</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Section - Get in Touch Form */}
      <div className="contact-bottom-section">
        <div className={`enquiry-form-full ${isVisible ? 'fade-in-up' : ''}`}>
          <div className="contact-card-header">
            <img src={contactIcon} alt="Get in Touch" className="contact-wheel-icon" />
            <span className="contact-header-title">Get in Touch</span>
          </div>
          
          <div className="enquiry-content">
            <p className="enquiry-intro">
              We'd love to assist you! Drop us a message, and our team will get back to you promptly.
            </p>
            
            {responseMessage.text && (
              <div className={`response-message ${responseMessage.type === "success" ? "success-message" : "error-message"}`}>
                {responseMessage.text}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="input-group">
                <input 
                  type="text" 
                  name="name" 
                  placeholder="Full Name" 
                  required 
                  value={formData.name} 
                  onChange={handleChange}
                  disabled={submitting}
                />
                <input 
                  type="email" 
                  name="email" 
                  placeholder="Email Address" 
                  required 
                  value={formData.email} 
                  onChange={handleChange}
                  disabled={submitting}
                />
              </div>
              <div className="input-group">
                <input 
                  type="tel" 
                  name="phone" 
                  placeholder="Phone Number" 
                  required 
                  value={formData.phone} 
                  onChange={handleChange}
                  disabled={submitting}
                />
                <input 
                  type="text" 
                  name="subject" 
                  placeholder="Subject" 
                  required 
                  value={formData.subject} 
                  onChange={handleChange}
                  disabled={submitting}
                />
              </div>
              <textarea 
                name="message" 
                placeholder="Your Message" 
                required 
                className="large-textarea" 
                value={formData.message} 
                onChange={handleChange}
                disabled={submitting}
              ></textarea>
              <button 
                type="submit" 
                className="enquiry-submit-btn"
                disabled={submitting}
              >
                {submitting ? (
                  <span className="btn-content">
                    <span className="spinner"></span>
                    Sending...
                  </span>
                ) : (
                  <span className="btn-content">
                    Send Message
                    <span className="arrow">→</span>
                  </span>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;